<template>
  <ul class="menu-nav" v-if="!$store.getters.isUserFreelancer">
    <router-link custom to="/aufgaben/overview" v-slot="{ href, navigate, isActive, isExactActive }">
      <li
        aria-haspopup="true"
        data-menu-toggle="click"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
      >
        <a :href="href" @click="navigate" class="menu-link menu-toggle">
          <span class="menu-text">Aufgaben</span>
          <b-badge
            v-if="notificationCount > 0"
            variant="danger"
            style="
              position: absolute;
              right: -10px;
              top: -10px;
              padding: 4px;
              border-radius: 12px;
              min-width: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              background-color: #e02424;
            "
          >
            {{ notificationCount }}
          </b-badge>
        </a>
      </li>
    </router-link>
    <li
      :aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{ 'menu-item-active': hasActiveChildren('/reisen/') }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text">Reisen</span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link custom to="/reisen/overview" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Reiseübersicht</span>
              </a>
            </li>
          </router-link>
          <router-link
            custom
            to="/reisen/prioritaeten"
            v-slot="{ href, navigate, isActive, isExactActive }"
            v-allowedRoles="[Role.ADMIN, Role.SALES]"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Prioritäten</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{ 'menu-item-active': isReisetermineActive }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text">Reisetermine</span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link
            custom
            to="/reisetermine/overview"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Reiseterminübersicht</span>
              </a>
            </li>
          </router-link>
          <li
            class="menu-item menu-item-submenu ml-0"
            data-menu-toggle="hover"
            aria-haspopup="true"
            v-allowedRoles="[Role.ADMIN, Role.YIELD, Role.PM, Role.AM, Role.CONTROLLING]"
          >
            <a class="menu-link menu-toggle">
              <span class="menu-text">Planung</span>
              <i class="menu-arrow"></i>
            </a>
            <div
              class="menu-submenu menu-submenu-classic menu-submenu-right"
              data-hor-direction="menu-submenu-right"
            >
              <ul class="menu-subnav">
                <router-link
                  custom
                  to="/restriktionen"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.PM, Role.YIELD]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Restriktionen</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/reisetermine/touristische-planung"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.CONTROLLING]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Touristische Planung</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/reisetermine/planung"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.PM, Role.YIELD]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Reiseterminplanung</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/reisetermine/flugplanung"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.YIELD, Role.PM]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Flugplanung</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/airlines"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.YIELD, Role.PM]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="isDisabled ? '#' : href" class="menu-link" @click="navigate">
                      <span class="menu-text">Airlines</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/flugstammdaten"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.AM]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="isDisabled ? '#' : href" class="menu-link" @click="navigate">
                      <span class="menu-text">Flugstammdaten</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/reisetermine/transferplanung"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.PM]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Transferplanung</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/reisetermine/kontrollansicht-daten"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  v-allowedRoles="[Role.ADMIN, Role.PM, Role.YIELD]"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Kontrollansicht Daten</span>
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
          </li>

          <router-link
            custom
            to="/reisetermine/reisefinder"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Reisefinder</span>
              </a>
            </li>
          </router-link>
          <li
            class="menu-item menu-item-submenu ml-0"
            data-menu-toggle="hover"
            aria-haspopup="true"
            v-allowedRoles="[Role.ADMIN, Role.YIELD]"
          >
            <a class="menu-link menu-toggle">
              <span class="menu-text">FVC</span>
              <i class="menu-arrow"></i>
            </a>
            <div
              class="menu-submenu menu-submenu-classic menu-submenu-right"
              data-hor-direction="menu-submenu-right"
            >
              <ul class="menu-subnav">
                <router-link
                  custom
                  to="/reisetermine/fvc/overview"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    v-allowedRoles="[Role.ADMIN, Role.YIELD]"
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">FVC-Übersicht</span>
                    </a>
                  </li>
                </router-link>
                <router-link
                  custom
                  to="/reisetermine/fvc/rm-reisebasis"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    v-allowedRoles="[Role.ADMIN, Role.YIELD]"
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">RM Reisebasis</span>
                    </a>
                  </li>
                </router-link>
                <router-link
                  custom
                  to="/reisetermine/fvc/kpi-dashboard"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    v-allowedRoles="[Role.ADMIN, Role.YIELD]"
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">KPIs</span>
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
          </li>
          <router-link custom to="/reisetermine/zvc" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              v-allowedRoles="[Role.ADMIN, Role.PM, Role.YIELD, Role.DOM, Role.CSM]"
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">ZVC</span>
              </a>
            </li>
          </router-link>

          <router-link
            custom
            to="/reisetermine/yield-controlling"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              v-allowedRoles="[Role.ADMIN, Role.YIELD]"
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Yield Controlling</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <li
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{ 'menu-item-active': hasActiveChildren('/vorgaenge/') }"
      v-allowedRoles="[Role.ADMIN, Role.FOM, Role.BUCHHALTUNG, Role.SALES]"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text">Vorgänge</span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link custom to="/vorgaenge/overview" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="click"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
              class="menu-item menu-item-submenu menu-item-open-dropdown"
              v-allowedRoles="[Role.ADMIN, Role.FOM, Role.SALES]"
            >
              <a :href="href" @click="navigate" class="menu-link menu-toggle">
                <span class="menu-text">Flugbuchungen Controlling</span>
              </a>
            </li>
          </router-link>
          <li
            class="menu-item menu-item-submenu ml-0"
            data-menu-toggle="hover"
            aria-haspopup="true"
            v-allowedRoles="[Role.ADMIN, Role.BUCHHALTUNG]"
          >
            <a class="menu-link menu-toggle">
              <span class="menu-text">Rechnungsprüfung</span>
              <i class="menu-arrow"></i>
            </a>
            <div
              class="menu-submenu menu-submenu-classic menu-submenu-right"
              data-hor-direction="menu-submenu-right"
            >
              <ul class="menu-subnav">
                <router-link
                  custom
                  to="/vorgaenge/rechnungspruefung/katalog-reisen"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                    v-allowedRoles="[Role.ADMIN, Role.BUCHHALTUNG]"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Katalog Reisen</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/vorgaenge/rechnungspruefung/fit-reisen"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                    v-allowedRoles="[Role.ADMIN, Role.BUCHHALTUNG]"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">FIT Reisen</span>
                    </a>
                  </li>
                </router-link>

                <router-link
                  custom
                  to="/vorgaenge/rechnungspruefung/zahllaeufe"
                  v-slot="{ href, navigate, isActive, isExactActive }"
                >
                  <li
                    aria-haspopup="true"
                    data-menu-toggle="hover"
                    class="menu-item"
                    :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
                    v-allowedRoles="[Role.ADMIN, Role.BUCHHALTUNG]"
                  >
                    <a :href="href" class="menu-link" @click="navigate">
                      <span class="menu-text">Zahlläufe</span>
                    </a>
                  </li>
                </router-link>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </li>
    <li
      v-allowedRoles="[Role.ADMIN, Role.OM]"
      aria-haspopup="true"
      data-menu-toggle="click"
      class="menu-item menu-item-submenu menu-item-open-dropdown"
      v-bind:class="{
        'menu-item-active':
          hasActiveChildren('/OM/') || hasActiveChildren('/kunden/') || hasActiveChildren('/agenturen/'),
      }"
    >
      <a href="#" class="menu-link menu-toggle">
        <span class="menu-text">{{ $t('KUNDEN.DUBLETTEN.PRUEFUNG') }}</span>
      </a>
      <div class="menu-submenu menu-submenu-classic">
        <ul class="menu-subnav">
          <router-link custom to="/kunden/confirmation" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Kunden</span>
              </a>
            </li>
          </router-link>
          <router-link
            custom
            to="/agenturen/confirmation"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
            <li
              aria-haspopup="true"
              data-menu-toggle="hover"
              class="menu-item"
              :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
              <a :href="href" class="menu-link" @click="navigate">
                <span class="menu-text">Agenturen</span>
              </a>
            </li>
          </router-link>
        </ul>
      </div>
    </li>
    <router-link
      custom
      to="/daten-upload/"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-allowedRoles="[Role.IMPORT, Role.ADMIN]"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="click"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
      >
        <a :href="href" @click="navigate" class="menu-link menu-toggle">
          <span class="menu-text">Daten-Upload</span>
        </a>
      </li>
    </router-link>
    <router-link
      custom
      to="/umfragen/"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-allowedRoles="[Role.ADMIN]"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="click"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
        class="menu-item menu-item-submenu menu-item-open-dropdown"
      >
        <a :href="href" @click="navigate" class="menu-link menu-toggle">
          <span class="menu-text">Umfragen</span>
        </a>
      </li>
    </router-link>
  </ul>
  <ul class="menu-nav" v-else>
    <router-link custom to="/reisetermine/overview" v-slot="{ href, navigate, isActive, isExactActive }">
      <a
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">{{ $t('COMMON.REISETERMINUEBERSICHT') }}</span>
        </a>
      </a>
    </router-link>
    <router-link custom to="/reisetermine/reisefinder" v-slot="{ href, navigate, isActive, isExactActive }">
      <a
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">{{ $t('COMMON.REISEFINDER') }}</span>
        </a>
      </a>
    </router-link>
  </ul>
</template>

<script>
import { mapState } from 'vuex';
import { Role } from '../../../core/user/roles';
export default {
  name: 'KTMenu',
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
  },
  computed: {
    ...mapState({
      notificationCount: state => state.aufgaben.notificationCount,
    }),
    isDisabled() {
      return true;
    },
    isReisetermineActive() {
      const path = this.$route.path;
      return ['/reisetermine/', '/restriktionen', '/airlines', '/ '].some(prefix => path.startsWith(prefix));
    },
  },
};
</script>
